import { formatData } from '../../../../helpers/data_format';

export interface MetadataItemProps {
  format?: string;
  name?: string;
  value?: string | number;
}

const MetadataItem = ({ format, name, value }: MetadataItemProps) => {
  return (
    <li>
      <span>{name}</span>
      {/* @ts-ignore - formatData is not typed yet */}
      <span>{formatData({ format, value })}</span>
    </li>
  );
};

export default MetadataItem;
